import React from 'react';

export default function AffiliateMarketingPolicy() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">
        <h1 className="text-3xl text-center font-bold text-purple-600 mb-6">
          Affiliate Marketing &amp; Referral Policy
        </h1>

        <p className="text-gray-700 mb-8">
          Million2Trillion (M2T) offers verified affiliate programs to allow members, educators, partners, and influencers to promote the platform while earning commissions on referred users and transactions.
        </p>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Affiliate Eligibility</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>All affiliate program participants must complete KYC verification prior to being approved as a verified referrer.</li>
          <li>Partners must agree to all M2T marketing guidelines, disclosure requirements, and ethical promotion standards.</li>
          <li>Fake traffic, bots, or non-human leads are strictly prohibited and automatically disqualified.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Commission Structure</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>Commission rates, payout cycles, and bonus tiers may vary based on affiliate level, verified status, and promotional performance.</li>
          <li>All commission earnings are transparently displayed inside the Affiliate Dashboard with real-time reporting.</li>
          <li>Commission earnings become eligible for withdrawal after any refund windows or compliance review periods are successfully cleared.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Promotion Rules</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>Affiliates must not promise guaranteed trading results, unrealistic income claims, or false financial advertising while promoting M2T services.</li>
          <li>All sponsored influencer partnerships must clearly disclose paid promotions to followers as per global disclosure laws.</li>
          <li>Keyword spamming, competitor sabotage, or unethical ad targeting is strictly prohibited in affiliate campaigns.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Account Violations &amp; Termination</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>Violation of any affiliate policy terms will result in immediate commission forfeiture and permanent affiliate account ban.</li>
          <li>M2T reserves full right to audit affiliate traffic sources, analytics data, or ad accounts upon request for compliance verification.</li>
        </ul>

        <p className="text-gray-500 italic mt-10">
          Affiliate partners help build M2T trust. Verified promotion builds verified growth — not artificial volume. Long-term partnerships require long-term ethical standards.
        </p>
      </div>
    </div>
  );
}
